import {
    Modal,
    NavigationItem,
    Spinner,
    VerticalContainer,
} from '@/components';
import {
    AddChildrenModalOptions,
    useAddChildren,
} from '@/features/shared/features/addOrEditChild/lib';
import { AddHouseholdMemberModal } from '@/features/profile/widgets/household/ui/AddHouseholdMemberModal';
import { ChildModal } from '@/features/shared/features/addOrEditChild/ui/ChildModal';

type AddChildrenModalProps = AddChildrenModalOptions & {
    title: string;
};

export function AddChildrenModal({
    title,
    allowedTypes,
    mode,
    onSubmitAdolescent,
    onClose,
    onChildAdded,
}: AddChildrenModalProps) {
    const {
        children,
        addChild,
        onChildClick,
        onClickCreateManually,
        getChildIcon,
        createManuallyCaption,
        showChildModal,
        prefilledChild,
        onCloseChildModal,
        onMutationSuccess,
        showAdolescentModal,
        adolescentInitialValues,
        onCloseAdolescentModal,
    } = useAddChildren({
        allowedTypes,
        mode,
        onSubmitAdolescent,
        onClose,
        onChildAdded,
    });

    return (
        <Modal onClose={onClose} title={title}>
            <VerticalContainer spacing="md" className="relative pt-2">
                {children.map((child) => (
                    <NavigationItem
                        key={child.CprNumber}
                        caption={child.FullName}
                        icon={getChildIcon(child)}
                        onClick={() => onChildClick(child)}
                    />
                ))}

                <NavigationItem
                    caption={createManuallyCaption}
                    onClick={onClickCreateManually}
                />

                {addChild.status === 'pending' && (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <Spinner />
                    </div>
                )}
            </VerticalContainer>

            {addChild.status === 'error' && <div>{addChild.errorMessage}</div>}

            {showChildModal && (
                <ChildModal
                    onClose={onCloseChildModal}
                    onMutationSuccess={onMutationSuccess}
                    mode={{ isEditing: false, isAdding: true }}
                    prefilledChild={prefilledChild}
                />
            )}

            {showAdolescentModal && onSubmitAdolescent && (
                <AddHouseholdMemberModal
                    onClose={onCloseAdolescentModal}
                    showAdolescentTerms={true}
                    onSubmitMember={onSubmitAdolescent}
                    initialValues={adolescentInitialValues}
                />
            )}
        </Modal>
    );
}
